@use '@design/design-tokens/typography/typography' as *;
@use '@design/design-tokens/border-radius/border-radius' as *;

@layer design-system {
  .priceChangesChartRoot {
    position: relative;
    overflow: visible;
  }

  .priceChangesChartContainer {
    overflow: visible;
  }

  .plot {
    position: relative;
    width: 100%;
    height: 340px;
    overflow: visible;
  }

  .canvasOverlay {
    position: absolute;
    pointer-events: none;
  }

  .verticalLine {
    stroke: var(--border-default);
    stroke-width: 2px;

    &.dashed {
      stroke-dasharray: 4 4;
    }
  }

  .tooltipLine {
    stroke-dasharray: 2 2;
    stroke-width: 2px;
    stroke: var(--border-soft);
  }

  .thresholdLine {
    stroke: var(--border-hover);
    stroke-width: 1px;
    stroke-dasharray: 1 6;
  }

  .thresholdLabelForeignObject {
    overflow: visible;
  }

  .thresholdLabelBlock {
    display: inline-flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
    padding: 4px 6px;
    background-color: rgba(var(--background-default-rgb), 0.8);
    @include border-radius-r2;
  }

  .thresholdLabel {
    color: var(--text-soft);
    @include typography-v2-body-xs;
  }

  .thresholdLabelPrice {
    color: var(--text-soft);
    font-family: var(--font-roboto-mono);
    @include typography-v2-body-xs;
  }
}
